import { useCallback, useState } from 'react';
import CategoryList from '../components/CategoryList';
import ComicList from '../components/ComicList';
import ViewModeToggle from '../components/ViewModeToggle';
import { useParams } from 'react-router-dom';
import { translateCategoryCodeToEnglish } from '../utils/categoryTranslations';
import { readViewMode, writeViewMode } from '../utils/viewMode';

const MyComicsPage = () => {
    const { categoryCode } = useParams();

    // Traduire le code français de l'URL vers le code anglais utilisé par l'API
    const englishCategoryCode = categoryCode ? translateCategoryCodeToEnglish(categoryCode) : categoryCode;

    const [viewMode, setViewMode] = useState(readViewMode);

    const changeViewMode = useCallback((mode) => {
        setViewMode(mode);
        writeViewMode(mode);
    }, []);

    return (
        <div className="hero-body">
            <div className="container">
                <h1 className="title is-2">Ma collection</h1>
                <ViewModeToggle mode={viewMode} onChange={changeViewMode} />
                <CategoryList />
                <ComicList categoryCode={englishCategoryCode} viewMode={viewMode} />
            </div>
        </div>
    );
}

export default MyComicsPage;
